// extracted by mini-css-extract-plugin
export default {"storyTimeline":"c-a_gE","storyTimeline__item":"c-a_gF","storyTimeline__item_complete":"c-a_gG","storyTimeline__item_withProgress":"c-a_gH"};